import { render } from "./Client.vue?vue&type=template&id=5003391e&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"

import "./Client.vue?vue&type=style&index=0&id=5003391e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5003391e"

export default script